import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSun,
  faMoon,
  faBars,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import "./Navbar.css";
import darkLogo from "../../../assets/logo/dark.png";
import lightLogo from "../../../assets/logo/light.png";

const Navbar = ({ scrolled, activeSection, handleNavClick }) => {
  const { darkMode, toggleTheme } = useContext(ThemeContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const navItems = [
    { title: "Home", href: "#home" },
    { title: "About", href: "#about" },
    { title: "Services", href: "#services" },
    { title: "Pricing", href: "#pricing" },
  ];

  return (
    <header
      className={`header ${isScrolled ? "scrolled" : ""} ${
        darkMode ? "dark-mode" : ""
      }`}
    >
      <div className="container-fluid px-4">
        <div className="row align-items-center">
          {/* Logo */}
          <div className="col-6 col-md-3">
            <a href="/" className="logo-link">
              <img
                src={darkMode ? lightLogo : darkLogo}
                alt="NUMRA Logo"
                className={`logo-img ${isScrolled ? "scrolled" : ""}`}
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="col-md-6 d-none d-md-block">
            <nav className="nav-links">
              {navItems.map((item) => (
                <a
                  key={item.title}
                  href={item.href}
                  className={`nav-link ${
                    activeSection === item.href.substring(1) ? "active" : ""
                  }`}
                  onClick={(e) =>
                    handleNavClick && handleNavClick(e, item.href.substring(1))
                  }
                >
                  {item.title}
                </a>
              ))}
            </nav>
          </div>

          {/* Right Side Actions */}
          <div className="col-6 col-md-3 d-flex align-items-center justify-content-end">
            <button
              className="theme-toggle-btn"
              onClick={toggleTheme}
              aria-label={
                darkMode ? "Switch to light mode" : "Switch to dark mode"
              }
            >
              <FontAwesomeIcon icon={darkMode ? faSun : faMoon} />
            </button>
            <a
              href="/login"
              className="login-btn ms-3 d-none d-md-inline-block"
            >
              Log In
            </a>
            <button
              className="mobile-menu-btn ms-3 d-md-none"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${mobileMenuOpen ? "show" : ""}`}>
          <nav className="mobile-nav-links">
            {navItems.map((item) => (
              <a
                key={item.title}
                href={item.href}
                className={`mobile-nav-link ${
                  activeSection === item.href.substring(1) ? "active" : ""
                }`}
                onClick={(e) => {
                  handleNavClick && handleNavClick(e, item.href.substring(1));
                  setMobileMenuOpen(false);
                }}
              >
                {item.title}
              </a>
            ))}
            <a href="/login" className="mobile-login-btn">
              Log In
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
